import { render, staticRenderFns } from "./paso5.vue?vue&type=template&id=5e22f593&scoped=true&"
import script from "./paso5.vue?vue&type=script&lang=ts&"
export * from "./paso5.vue?vue&type=script&lang=ts&"
import style0 from "./paso5.vue?vue&type=style&index=0&id=5e22f593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22f593",
  null
  
)

export default component.exports